const updateAddDocumentServices = {
  toastr: 'Document updated',
  toastr1: 'The document was successfully updated'
};

export default updateAddDocumentServices;
